import styled from '@emotion/styled';

export const TextWrapper = styled.div<{ lines: number }>`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${({ lines }) => lines};
  overflow: hidden;
  text-overflow: ellipsis;
`;
